import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-img-change",
  "use": "icon-img-change-usage",
  "viewBox": "0 0 13 13",
  "content": "<symbol viewBox=\"0 0 13 13\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-img-change\"><g><rect height=\"9\" rx=\".5\" width=\"9\" x=\".5\" y=\"3.5\" /><rect height=\"9\" rx=\".5\" width=\"9\" x=\"3.5\" y=\".5\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol